export type RemoveOrganizationCarTranslations = {
  removeCar: string;
  removeCarTitle: string;
  removeCarDescription: (carName: string) => string;
  removeCarReason: string;
  selectReason: string;
  reasonSold: string;
  reasonWrecked: string;
  reasonNeverOwned: string;
  reasonOther: string;
  removeCarNote: string;
  removeCarNotePlaceholder: string;
  carRemoved: (carName: string) => string;
};

export const defaultRemoveOrganizationCarTranslations: RemoveOrganizationCarTranslations = {
  removeCar: 'Remove car',
  removeCarTitle: 'Remove car from this organization?',
  removeCarDescription: (carName) => `Remove ${carName} from this organization? Past bookings stay as they are.`,
  removeCarReason: 'Reason',
  selectReason: 'Select a reason',
  reasonSold: 'Sold',
  reasonWrecked: 'Wrecked / scrapped',
  reasonNeverOwned: 'Never owned (not mine)',
  reasonOther: 'Other',
  removeCarNote: 'Note',
  removeCarNotePlaceholder: 'Why this car is leaving the organization',
  carRemoved: (carName) => `${carName} removed from the organization`
};
